<template>
  <div class="accordion-item category" :class="lastItem ? '' : 'mb-4'">
    <button @click="toggleContent($event)" class="flex items-center justify-between w-full px-3 py-3 rounded-sm cursor-pointer md:px-5" type="button" :aria-expanded="expanded">
      <h3 class="inline-block mr-4 text-base text-left normal-case md:text-xl md:mr-0">{{ name }}</h3>
      <div class="flex items-center">
        <span v-if="parentText" class="mr-5">{{ parentText }}</span>
        <span v-if="tagText" class="mr-5 w-8">{{ tagText }}</span>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 22 22" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.74697 9.75166L9.74697 1.25298H12.2529V20.7449L9.74697 20.7449L9.74697 12.2568L1.25387 12.2538L1.25387 9.75166L9.74697 9.75166ZM20.746 12.2541H14.255L14.255 9.7481H20.746L20.746 12.2541Z"
              fill="#2C2827" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 22 22" fill="none">
            <path d="M20.7449 12.253H1.25299L1.25299 9.74703H20.7449L20.7449 12.253Z" fill="#E07300" />
          </svg>
        </div>
      </div>
    </button>
    <div class="px-3 pb-4 text-left md:px-5 accordion-content" :class="hiddenFromStart ? 'hidden' : ''">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ellevio-web-accordion',
  props: {
    name: {
      type: String,
      required: true
    },
    tagText: {
      type: String,
      required: false
    },
    parentText: {
      type: String,
      required: false
    },
    hiddenFromStart: {
      type: Boolean,
      default: true
    },
    lastItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: !this.hiddenFromStart
    }
  },
  methods: {
    toggleContent($event) {
      $event.currentTarget.parentElement.querySelector('.accordion-content').classList.toggle('hidden')
      this.expanded = !this.expanded
    }
  }
}
</script>
<style scoped>
.accordion-item {
  @apply bg-white rounded-lg accordion-parent border-1 border-newColors-gray-baseB;
}
.accordion-parent:has(.accordion-content.hidden) div > svg:first-child {
  display: block;
}
.accordion-parent:has(.accordion-content.hidden) div > svg + svg {
  display: none;
}
.accordion-parent:not(:has(.accordion-content.hidden)) div > svg:first-child {
  display: none;
}
.accordion-parent:not(:has(.accordion-content.hidden)) div > svg + svg {
  display: block;
}
.accordion-parent:has(.accordion-content.hidden) div > svg:first-child path {
  fill: #2c2827;
  transition: fill 0.3s ease-in-out;
}
.accordion-parent:has(.accordion-content.hidden):hover div > svg:first-child path {
  fill: #ff8300;
}

.accordion-parent:has(.accordion-content) {
  box-shadow: none;
  transition: box-shadow 0.3s ease-in-out;
}
.accordion-parent:has(.accordion-content):hover {
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  border-color: #cdcbca;
}

button:focus:focus-visible {
  outline: 2px dotted #000;
  outline-offset: 3px;
}
</style>
